import { BaseEntity } from '../../base-entity';

export enum LectureActivationCode {
  MANUAL = 'MANUAL',
  NATURAL = 'NATURAL',
}

export interface LectureSessionEntity extends BaseEntity {
  id: number;
  userId: number;
  lectureId: number;
  startAt: Date;
  endAt: Date | null;
  startActivationType: LectureActivationCode;
  endActivationType: LectureActivationCode;
}
